var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Badge,{staticClass:"tw-capitalize",attrs:{"status":_setup.status,"resizable":""}},[_vm._v("\n  "+_vm._s(_vm.entityType)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }